import React, { useRef, useState, useEffect } from 'react';
import cn from 'classnames';
import styles from "./SegmentControl.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function SegmentControl(_ref) {
  let {
    options,
    value,
    onChange,
    variant = 'text',
    className,
    'data-testid': testId,
    'aria-label': ariaLabel
  } = _ref;
  const containerRef = useRef(null);
  const segmentRefs = useRef([]);
  const [isInitialized, setIsInitialized] = useState(false);
  const selectedIndex = options.findIndex(opt => opt.value === value);
  const n = options.length;
  const pillStyle = selectedIndex >= 0 && n > 0 ? {
    left: "".concat(selectedIndex / n * 100, "%"),
    width: "".concat(1 / n * 100, "%")
  } : {
    left: '0%',
    width: '0%'
  };
  useEffect(() => {
    if (!isInitialized) {
      requestAnimationFrame(() => {
        setIsInitialized(true);
      });
    }
  }, [isInitialized]);
  const handleKeyDown = (event, index) => {
    let newIndex = index;
    if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
      event.preventDefault();
      newIndex = (index + 1) % options.length;
    } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
      event.preventDefault();
      newIndex = (index - 1 + options.length) % options.length;
    } else if (event.key === 'Home') {
      event.preventDefault();
      newIndex = 0;
    } else if (event.key === 'End') {
      event.preventDefault();
      newIndex = options.length - 1;
    }
    if (newIndex !== index) {
      var _segmentRefs$current$;
      onChange(options[newIndex].value);
      (_segmentRefs$current$ = segmentRefs.current[newIndex]) === null || _segmentRefs$current$ === void 0 || _segmentRefs$current$.focus();
    }
  };
  return /*#__PURE__*/_jsxs("div", {
    ref: containerRef,
    className: cn(styles.container, className),
    "data-testid": testId,
    role: "radiogroup",
    "aria-label": ariaLabel,
    children: [/*#__PURE__*/_jsx("div", {
      className: cn(styles.pill, isInitialized && styles.animated),
      style: {
        left: pillStyle.left,
        width: pillStyle.width
      },
      "aria-hidden": "true",
      role: "presentation"
    }), /*#__PURE__*/_jsx("div", {
      className: styles.segmentsWrapper,
      children: options.map((option, index) => {
        const isSelected = option.value === value;
        const segmentClass = variant === 'icon' ? styles.iconSegment : styles.textSegment;
        return /*#__PURE__*/_jsx("button", {
          ref: el => {
            segmentRefs.current[index] = el;
          },
          type: "button",
          role: "radio",
          "aria-checked": isSelected,
          tabIndex: isSelected ? 0 : -1,
          className: cn(styles.segment, segmentClass, isSelected && styles.selected),
          onClick: () => onChange(option.value),
          onKeyDown: e => handleKeyDown(e, index),
          "data-testid": option['data-testid'],
          children: variant === 'icon' ? option.icon : option.label
        }, option.value);
      })
    })]
  });
}